
import React from "react";

type Props = {
  left: number;
  top: number;
}

const GanttChartBodyMilestone = (props: Props) => {

  const left = props.left + 4
  const top = props.top + 6

  return (
    <g className="gantt-chart-item-milestone">
      <rect
        className="grid-row-item-milestone"
        width="18"
        height="18"
        x="1"
        y="0"
        rx="3"
        ry="3"
        transform={`translate(${left + 12},${top - 4}) rotate(45)`}
      />
    </g>
  )
}

export default GanttChartBodyMilestone
